import { DateTime } from "luxon";
import { BaseJob } from "./job.type";
import { Waypoint } from "./waypoint.type";
import { NonServiceAction } from "./non-service-action.type";
import { NonServicePeriod } from "./non-service-period.type";
import { ScheduledFlagStop } from "./flag-stop.type";


export enum VmType {
  NonServiceAction = 'nonServiceAction',
  NonServicePeriod = 'nonServicePeriod',
  Group = 'group',
  Job = 'job',
  ScheduledFlagStop = 'scheduledFlagStop',
  Waypoint = 'waypoint',
}

export const VmTypes = Object.values(VmType);

export type ScheduledEvent<T = BaseJob | ScheduledFlagStop | NonServicePeriod | NonServiceAction | GroupedStop | Waypoint> = T & {
  id?: string | number,
  vmType?: VmType,
  scheduledDateTime?: DateTime,
  stopSequence?: number,
  completed?: boolean,
};

export type GroupedStop = {
  time?: DateTime,
  count?: number,
  jobs?: ScheduledEvent<BaseJob | Waypoint>[],
}
